export default __webpack_public_path__ + "static/media/banner2.8e31f921.jpg";